namespace nscs.util {
    export class TextTyper {

        private typeCounter: number = 0;

        private typeString: string = "";

        private typeTimer: Phaser.Time.TimerEvent;

        private scene:Phaser.Scene;
        private textField:Phaser.GameObjects.Text;

        private onComplete:()=>void;

        constructor(scene:Phaser.Scene, textField:Phaser.GameObjects.Text, onComplete:()=>void = null) {
            this.scene = scene;
            this.textField = textField;
            this.onComplete = onComplete;
        }

        public typeText(newString: string, speed: number = 1/35): any {
            nscs.util.Functions.updateTextFieldPosition(this.textField, "");
            this.typeCounter = 0;
            this.typeString = newString;

            this.stop();

            this.typeTimer = this.scene.time.addEvent({
                delay: 1/speed,
                callback: this.advanceLetter,
                callbackScope: this,
                loop: true
            });
        }

        public setText(newText: string): void {
            this.typeCounter = this.typeString.length;
            nscs.util.Functions.updateTextFieldPosition(this.textField, newText);
            this.stop();
        }

        public isDone(): boolean {
            return /*this.lines.length == 0 && */this.typeCounter >= this.typeString.length;
        }

        public advanceLetter: () => void = () => {
            if (!this.textField.parentContainer) return;

            var nextSpace: number = NaN;
            var prevSpace: number = NaN;
            var prevHeight: number = NaN;
            this.typeCounter++;
            if (this.typeCounter <= this.typeString.length) {
                // GameWorld.soundManager.playSound("dialog");
                nextSpace = this.typeString.indexOf(" ", this.typeCounter);
                if (nextSpace == -1) {
                    nextSpace = this.typeString.length;
                }
                prevSpace = Math.max(0, this.typeString.lastIndexOf(" ", this.typeCounter));
                nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                prevHeight = this.textField.height;
                nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, nextSpace));
                if (prevHeight != this.textField.height && (this.typeString.indexOf("\n", prevSpace) >= nextSpace || this.typeString.indexOf("\n", prevSpace) == -1)) {
                    nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, prevSpace) + "\n" + this.typeString.substr(prevSpace + 1, this.typeCounter - (prevSpace + 1)));
                } else {
                    nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                }
            } else {
                nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeString.length));
                this.stop();
                if (this.onComplete) this.onComplete();
            }
        };

        public stop():void {
            if (this.typeTimer) {
                this.typeTimer.remove();
                this.typeTimer = null;
            }
        }
    }
}